import { useEffect, useRef, useState } from "react";
import MainRecording from "./mainrecordingscreen";

import V2EditScreen from "./v2editscreen";
import api from "api/api";
import { useDispatch } from "react-redux";
import { setSavedload, setSelectedTab } from "../redux/store";
import useModalStore from "zustand/zustandstore";
import { useSelector } from "react-redux";
import SideBar from "./sidebar";
import { Backdrop, CircularProgress } from "@mui/material";
import Staticeditscreen from "./staticeditscreen";
import useAudioRecorder from "streaming/audiorecorderhook";
import DeleteConfirmation from "streaming/deleteconfirmation";
import ExitModal from "streaming/exitmodal";
import { saveAudioInIndexDB } from "offlinestreaming/offlineBlobHandler";
import RecordRTC, { StereoAudioRecorder } from "recordrtc";
import AuthOverlayCard from "pages/landing/overlayauth/authoverlay";
import TermsOverlayCard from "pages/landing/overlayauth/termsoverlay";
import ConstentAcceptance from "./../alerts/recordingscreen/consentacceptance";
import StreamingCombineToastModal from "alerts/recordingscreen/streamingcombine";
import { useParams } from "react-router-dom";
import SideBarWrapper from "./sidebarwrap";
import UploadAudio from "pages/templatecreation/uploadaudio";
import ToastMessage from "utils/muialerts/righttoptoast";
import ImageModal from "./modals/imagemodal";
import VisitSummarymodal from "./modals/visitsummarymodal";
import MRModal from "./modals/mrmodal";
import { generateFilename } from "./utils/filename";
import Encountermodal from "./modals/encountermodal";
import { eventBus } from '../utils/eventbus/eventBus';
import CareIq from "careiq/ui/careiq";
import CareEditScreen from "careiq/ui/careEditScreen";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
const V2Dashboard = () => {
  const mydata = useModalStore();
  const [ui, setUi] = useState(0); // 0 = Default, 1 = MainRecording, 2 = V2EditScreen
  const recorderRef = useRef(null);
  const [user, setUser] = useState("");
  const [deleteconfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0); // Total elapsed time in seconds
  const startTimeRef = useRef(null); // Tracks the timer's start/resume time
  const timerRef = useRef(null); // Reference to the timer interval
  const audioStreamRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [exitModal, setExitModal] = useState(false);
  const [isError, setIsError] = useState(false);
  const streamname = useRef();
  const pausedref = useRef(false);
  const [isencountermodal,setIsEncounterModal]=useState(false)
  const[encounterdata,setEncounterdata]=useState({})
  const[rosdata,setRosData]=useState({})
   const pollingRef = useRef(null);
const isuploadaudioflow=useRef(false)
  const { careiqRecord } = useModalStore();
const [rosmodal,setRosmodal]=useState(false)
const[rosloading,setRosLoading]=useState(false)
  const blocker = useRef(false);
  const wsRef = useRef(null);
  const ismanualstop = useRef(false);
  const [selectedRecord, setSelectedRecord] = useState("");
  const ismanualrecordstart = useRef(false);
  const [streamfilename, setStreamfilename] = useState("");
  const [streamingcombine, setStreamingCombine] = useState(false);
  const [latestapp, setLatestApp] = useState({});
  const [showdetailsmodal, setDetailsModal] = useState(false);
    const[pagedata,setPageData]=useState({})
  const token = sessionStorage.getItem("auth");
  const patientnameref=useRef()
  const streamobj=useRef({})
  const combinestatus=useRef(false)
  const isFirstStream=useRef(false)
  const streamfilenameref=useRef('')
    const { setModalValue } = useModalStore()
  const [recentRecord,setRecentRecord]=useState({})
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const onSaving = (blob) => {
    if (blob && blob.type.startsWith("audio/")) {
      console.log("Valid audio blob:", blob);
      // Call the function to submit the audio blob
      if (blocker.current) {
        return;
      }
      console.log("submitting blob");
      submitAudioBlobManually(blob);
    } else {
      console.error("Invalid blob. Not an audio file.");
    }
  };
  const {
    manualrecord,
    stopmanualRecording,
    pausemanualRecording,
    resumemanualRecording,
  } = useAudioRecorder(onSaving);
  const [id, setId] = useState();
  const [name, setName] = useState("");


  const dispatch = useDispatch();


  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [consentModal, setConsentModal] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [loguser, setLoguser] = useState("");
  const [getuserLoading, setGetUserLoading] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templates, setTemplate] = useState([]);
  const userref=useRef({})
  const [isverified, setIsVerified] = useState(0);
  const [isimgdata,setisimgdata]=useState({})
  const [isTimeLineLoading,setIstimeLineLoading]=useState(false)
    const [imgdata,setImgData]=useState([])
    const [timelinedata,setTimeLineData]=useState({})
      const [ismrmodal,setIsMrmodal]=useState(false)
      const [ismrdata,setismrdata]=useState({})
        const [visitsummarydata,setvisitsummary]=useState({})
        const [isvisitsummarygmodal,setIsvisitsummarymodal]=useState(false)
        const [isimgmodal,setIsimgmodal]=useState(false)
  const [apploading, setAppoloading] = useState(false);
    const [isuploadmodal,setIsuploadmodal]=useState(false)
//   useEffect(()=>{
// if(mydata.screen!==ui){
//   setUi(mydata.screen)
// }
//   },[mydata])
  const fetchusers = async () => {
    try {
      setGetUserLoading(true);
      const response = await api.get("/auth/me");
      setLoguser(response);
      if (response?.bm_user) {
        if (response?.disclaimer == "PENDING") {
          setIsVerified(2);
        } else {
          setIsVerified(0);
        }
      } else {
        setIsVerified(1);
      }
    } catch (error) {
    } finally {
      setGetUserLoading(false);
    }
  };
  const checkConsent = async () => {
   

    try {
      setLoading(true);
      const user = await api.get("/auth/me");
    
    userref.current=user
      if (user?.config?.consent_required == 0) {
        handlestartrecording();
        return;
      }

      const response = await api.get(
        `/v1/patients/get/${Number(mydata.selectedRecord?.patientid)}`
      );

      if (response.status == 200) {
        if (response?.data.consent_to_record == 1) {
          handlestartrecording();
        } else {
          setConsentModal(true);
        }
      } else {
        setConsentModal(true);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleAcceptance = async () => {
    setLoading(true);
    try {
      const response = await api.put(`/v1/patients/consent-update`, {
        patient_id: mydata.selectedRecord.patientid,
        consent_to_record: true,
      });
      if (response.status === 200) {
        setConsentModal(false);
         handlestartrecording()
      } else {
        setConsentModal(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const setDeftemp=()=>{
if(mydata.usertype!=='PRO'){
  return
}


const appointmentTypeId = mydata?.selectedRecord?.appointmenttypeid;

if (
  typeof appointmentTypeId === 'number' &&
 userref.current?.config?.appointmenttypeids?.includes(appointmentTypeId)
) {

  const matchedTemplate = userref.current?.templates?.templates?.find(template =>
    template?.appointment_type_ids?.includes(appointmentTypeId)
  );

  if (matchedTemplate?.template) {
    setSelectedTemplate(matchedTemplate.template);
  } else {
    setSelectedTemplate(userref.current?.templates?.default_template || "");
  }
} else {
  setSelectedTemplate(userref.current?.templates?.default_template || "");
}

  }
useEffect(()=>{
setDeftemp()
},[mydata.selectedRecord,userref])

  const fetchproTemplates = async () => {
    try {
      setLoading(true);
      const response = await api.get("/auth/me");
      // const dataRes = await api.get(
      //   "/v1/user_templates/get_populated_templates"
      // );
      userref.current=response
      var usertemp=[]
      if (response.templates && Array.isArray(response.templates.templates)) {
        // const transformedTemplates = response.templates.templates
        // .filter(obj => obj.template && obj.prompt) // Ensure required keys exist
        // .map(obj => ({
        //     [obj.template]: { prompt: obj.prompt }
        // }));
        const transformedTemplates = response.templates.templates
        .filter(obj => obj.sections) // Ensure required keys exist
        .map(obj => ({
            [obj.template]: { prompt: obj.sections },
            'base_template':obj.base_template
        }));
    usertemp=transformedTemplates

 
    }
      const defaultRes = await api.get(
        "/v1/user_templates/default_populated_templates"
      );

      if (usertemp.length && defaultRes.status === 200) {
        const combinedTemplates = [
          ...defaultRes?.file_names,
     
         ...usertemp
        ];
        const allKeys = combinedTemplates.map((item) => Object.keys(item)[0]);

        setTemplate(allKeys);
      } else if (usertemp.length) {
        const allKeys = usertemp.map((item) => Object.keys(item)[0]);
        setTemplate(allKeys);
      } else if (defaultRes.status === 200) {
        const allKeys = defaultRes?.file_names.map(
          (item) => Object.keys(item)[0]
        );
        setTemplate(allKeys);
      }


      

    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  const fecthtemplates = async () => {
    try {
      const response = await api.get("/auth/me");
      if (
        response &&
        response.templates 
      
      ) {
    
        var usertemp=[]
        if (response.templates && Array.isArray(response.templates.templates)) {
          const transformedTemplates = response.templates.templates
          .filter(obj => (obj.template && obj.prompt) || (obj.template === 'HnP'||obj.template === 'soap_note'))
          .map(obj => ({
              [obj.template]: { prompt: obj?.prompt||'' }
          }));
      usertemp=transformedTemplates

   
      }

        if (usertemp.length) {
           const allKeys = usertemp.map((item) => Object.keys(item)[0]);
          
        // Add 'HnP' if it's not already in the array
  // if (!allKeys.includes('HnP')) {
  //   allKeys.push('HnP');
  // }

  // Add 'soap_note' if it's not already in the array
  // if (!allKeys.includes('soap_note')) {
  //   allKeys.push('soap_note');
  // }
          // setTemplate(allKeys);
          const response = await api.get('/v1/user_templates/default_templates');

          if (response.status === 200) {
          const getkeys = response.file_names.map((item) => Object.keys(item)[0]);
          
          getkeys.forEach((key) => {
          if (!allKeys.includes(key)) {
          allKeys.push(key);
          }
          });
          setTemplate(allKeys)
        }
        
        }else{
          const response=await api.get('/v1/user_templates/default_templates')
          if(response.status==200){
           const allKeys = response.file_names.map((item) => Object.keys(item)[0]);
           setTemplate(allKeys)
          }else{
           setTemplate([])
          }
        }

        setSelectedTemplate(response.templates.default_template);
      }else{
        const response=await api.get('/v1/user_templates/default_templates')
         if(response.status==200){
          const allKeys = response.file_names.map((item) => Object.keys(item)[0]);
          setTemplate(allKeys)
         }else{
          setTemplate([])
         }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchuser = async () => {
    try {
      const response = await api.get("/auth/me");
      setUser(response);

             setLoguser(response)
    } catch (error) {}
  };
  const fetchBasicData=async()=>{
    try {
         const response=await api.get('/v1/user_templates/default_templates')
         if(response.status==200){
          const allKeys = response.file_names.map((item) => Object.keys(item)[0]);
          setTemplate(allKeys)
         }else{
          setTemplate([])
         }
    } catch (error) {
      
    }finally{

    }
  }
  useEffect(() => {
    if (mydata.usertype == "PLUS") {
      fecthtemplates();
    } else if (mydata.usertype === "PRO") {
      fetchproTemplates();
    } else if (mydata.usertype === "BASIC") {
fetchBasicData()
      setSelectedTemplate("Soap Note");
    }

    fetchuser();
  }, []);
  const submitAudioBlobManually = async (blob) => {
    try {
      console.log("inserting into index db ...");


      if (mydata.usertype === "PRO") { 
      
      const practiceid = user?.config?.practiceid || "";
      const departmentid = user?.config?.departmentid || "";
let obj={
  file: blob,
  practiceid: user?.config.practiceid, //required
  departmentid: user?.config.departmentid, //required,
  patientid:mydata.selectedRecord?.patientid, 
   
  patientname:mydata.selectedRecord?.patient_name,
   role: mydata.usertype, 
     filename:streamname.current,
    
     appointmentid:mydata.selectedRecord?.appointmentid,
     streamingfilename:streamfilenameref.current,
     userid: user?.id,
     templatename:selectedTemplate
}
if (combinestatus.current) {
  obj.rowid=latestapp?.id
 obj.category='combine'
}
saveAudioInIndexDB(obj);
      }else{
        const isBusinessUser = mydata.usertype === "BUSINESS";
        const tags = isBusinessUser ? patientnameref.current : "Sample tags";
        const patientid = isBusinessUser ? 1000 : patientId;
        const notes = isBusinessUser ? patientId : "Sample notes";
let obj={
   file: blob,
   filename: streamname.current,
    role: mydata.usertype,
          practiceid: user?.config.practiceid, //required
          departmentid: user?.config.departmentid, //required,
             patientid: patientid,  
               notes:notes,
               tags:tags,
      templatename:    !isBusinessUser ?selectedTemplate:'',
      userid: user?.id,
        patientname: !isBusinessUser ? patientName:'',
}
   saveAudioInIndexDB(obj);

      }


   
    } catch (error) {
      console.log(error);
    } finally {
      setIsError(false);
      setExitModal(false);
    }
  };
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const startTimer = () => {
    startTimeRef.current = Date.now() - elapsedTime * 1000; // Adjust for any previously elapsed time
    timerRef.current = setInterval(() => {
      const timePassed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setElapsedTime(timePassed);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  const togglePause = () => {
    if (isPaused) {
      // Resume the timer
      pausedref.current = false;
      if (ismanualrecordstart) {
        resumemanualRecording();
      }

      startTimer();
    } else {
      // Pause the timer
      pausedref.current = true;
      if (ismanualrecordstart) {
        pausemanualRecording();
      }

      stopTimer();
    }
    setIsPaused((prev) => !prev);
  };

  const handlestartrecording = () => {
    const currentDate = new Date();
    const timestampDate = new Date(mydata.selectedRecord?.ts);
    const currentDateMidnight = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const timestampDateMidnight = new Date(
      timestampDate.getFullYear(),
      timestampDate.getMonth(),
      timestampDate.getDate()
    );
    if (timestampDateMidnight > currentDateMidnight) {
      setAlertMessage("Recording for future dates is not allowed.");
      setSeverity("info"); // Change severity as needed
      setOpen(true);
    } else {
      if (mydata.isOpen) {
        setAlertMessage("Recording already in progress");
        setSeverity("info"); // Change severity as needed
        setOpen(true);
        return;
      }

      checkappointments();
    }
  };
const setstatus=async({status,appointmentid})=>{
  return
  try {
    await api.put('v1/appointments/status',{
      "appointment_id": 605105,
      "status":status
    })
  } catch (error) {
   console.log(error) 
  }
}


  const checkappointments = async () => {
    try {
      setAppoloading(true);
      const response = await FetchRecorderData();
      setAppoloading(false);
  if (response[1] && Array.isArray(response[1]) && response[1].length) {
  console.log("✅ Appointments found in response[1]:", response[1]);

  const currentappontments = response[1].filter(
    (x) => x.appointmentid == mydata.selectedRecord?.appointmentid
  );
  console.log("🔍 Filtered appointments with matching ID:", currentappontments);

  if (!currentappontments.length) {
    console.warn("⚠️ No matching appointments found.");

    if (isuploadaudioflow.current) {
      console.log("🎙️ Audio upload flow active — opening upload modal.");
      setIsuploadmodal(true);
      return;
    }

    console.log("▶️ No matching appointment but not in upload flow — starting recording...");
    startRecording();
    return;
  }

  const getLatestAppointment = (appointments) => {
    console.log("🧠 Computing latest appointment from:", appointments);
    return appointments.reduce((latest, appointment) => {
      return new Date(appointment.ts) > new Date(latest.ts)
        ? appointment
        : latest;
    });
  };

  const latestAppointment = getLatestAppointment(currentappontments);
  console.log("🕒 Latest appointment selected:", latestAppointment);

  const appointmentDate = new Date(latestAppointment.ts);
  const today = new Date();

  // Normalize to midnight for date-only comparison
  appointmentDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  console.log("📅 Comparing appointment date:", appointmentDate, "with today:", today);

  // if (appointmentDate.getTime() === today.getTime()) {
  if (true) {
    console.log("✅ Proceeding with latest appointment:", latestAppointment);
    setLatestApp(latestAppointment);
    setStreamingCombine(true);
  } else {
    console.warn("🚫 Appointment date is not today.");
  }
} else {
        if(isuploadaudioflow.current){
          setIsuploadmodal(true)
          return
        }
        startRecording();
  
        
      }
    } catch (error) {
      console.log(error);
      setAlertMessage("Looks like something went wrong. Please try again.");
      setSeverity("info"); // Change severity as needed
      setOpen(true);
    } finally {
      setAppoloading(false);
    }
  };
  const startRecording = async () => {
    pausedref.current = false;
    try {
      const filename = crypto.randomUUID();
      setStreamfilename(filename);
      streamname.current = filename;
      
      const practiceid = user?.config?.practiceid || "";
      const departmentid = user?.config?.departmentid || "";
      
      let ws; // Declare ws before the conditions
      
      if (mydata.usertype === "PRO") { 
        let filenameobj={
          fileExtension:'txt',
          practiceid:practiceid,
          departmentid:departmentid,
          patientid:mydata.selectedRecord?.patientid,
          appointmentid :mydata.selectedRecord?.appointmentid,
          currentUser:mydata.usertype,
        }
        setStreamingCombine(false)
        if (combinestatus.current) {
        filenameobj.rowid=latestapp?.id
        filenameobj.filename=latestapp?.audiolink
        filenameobj.category='combine'
        }
        const generatedfilename=generateFilename(filenameobj)
        // WebSocket URL for "PRO" user
        let url = `wss://api.prd.brainymed.com/bs/v1/recording/streaming?token=${token}&generated_file_name=${generatedfilename}&stream_filename=${filename}&practiceid=${practiceid}&departmentid=${departmentid}&patientid=${mydata.selectedRecord?.patientid}&appointmentid=${mydata.selectedRecord?.appointmentid}&template_name=${'HnP'}&notes=${encodeURIComponent('Sample notes')}&tags=${encodeURIComponent("Sample tags")}&patientname=${encodeURIComponent(mydata.selectedRecord?.patient_name)}`;

        if (combinestatus.current) {
          streamfilenameref.current=latestapp?.audiolink
          url += `&category=combine&filename=${latestapp?.audiolink}&rowid=${latestapp?.id}`;
          
        }
        
        ws = new WebSocket(url);
        



      } else {
        // WebSocket URL for "BUSINESS" and other users
        const isBusinessUser = mydata.usertype === "BUSINESS";
        const tags = isBusinessUser ? patientName : "Sample tags";
        const patientid = isBusinessUser ? 1000 : patientId;
        const notes = isBusinessUser ? patientId : "Sample notes";
        patientnameref.current=patientName
        const generatedfilename=generateFilename({
          practiceid: practiceid,
          departmentid: departmentid,
          patientid:patientId,   
          currentUser: mydata.usertype,
          fileExtension:'txt',    
        });
 
        ws = new WebSocket(
          `wss://api.prd.brainymed.com/bs/v1/recording/streaming?token=${token}&generated_file_name=${generatedfilename}&stream_filename=${filename}&practiceid=${practiceid}&departmentid=${departmentid}&patientid=${patientid}&notes=${encodeURIComponent(
            notes
          )}&tags=${encodeURIComponent(tags)}${
            !isBusinessUser ? `&patientname=${encodeURIComponent(patientName)}` : ""
          }${
            !isBusinessUser ? `&template_name=${encodeURIComponent(selectedTemplate)}` : ""
          }`
        );
      }
      
      // Now `ws` is defined and accessible throughout the function
      

      wsRef.current = ws;

      ws.onopen = () => {
        setModalValue({recording:true})
        console.log("WebSocket connection established.");
        setAlertMessage("Recording Started");
        setSeverity("success"); // Change severity as needed
        setOpen(true);
       if(mydata.usertype==='PRO'){
        setstatus({status:"recording",appointmentid:mydata.selectedRecord?.appointmentid})
       }
        setUi(2);
        // if(mydata.usertype==='PRO'){
        //   ExtractRos()
        //   fetchtimeline()
        //   fetchimgdata()
        // }
        isFirstStream.current=true
      };
 
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        if(mydata.usertype==='PRO'){
          setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
         }
        if(isFirstStream.current){
           ismanualrecordstart.current = true;
        manualrecord();
        return
        }
        setModalValue({recording:false})
        setAlertMessage("Connection Error");
        setSeverity("error"); // Change severity as needed
        setOpen(true);
       
      };

      ws.onclose = () => {
        if(mydata.usertype==='PRO'){
          setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
         }
        if (!ismanualstop.current) {
          ismanualrecordstart.current = true;
          console.log("manual record initiated");
          manualrecord();
          return
        }
        setModalValue({recording:false})
isFirstStream.current=false

        console.log("WebSocket connection closed.");
      };

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioStreamRef.current = stream;
      const recorder = new RecordRTC(stream, {
        type: "audio",
        recorderType: StereoAudioRecorder,
        mimeType: "audio/webm",
        timeSlice: 5000, // Send data every 5 seconds
        desiredSampRate: 48000,
        numberOfAudioChannels: 1,
        ondataavailable: async (blob) => {
          if (ws.readyState === WebSocket.OPEN && !pausedref.current) {
            try {
              const base64Data = await blobToBase64(blob);
              ws.send(base64Data);
            } catch (error) {
              console.error("Error converting blob to base64:", error);
            }
          }
        },
      });

      recorder.startRecording();
      recorderRef.current = recorder;

      setElapsedTime(0);
      startTimer();
      setIsRecording(true);
      setIsPaused(false);
    } catch (error) {
      console.error("Error starting recording:", error);
      if(mydata.usertype==='PRO'){
        setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
       }
       setModalValue({recording:false})
    }
  };

  const stopRecording = () => {
    ismanualstop.current = true;
    ismanualrecordstart.current = false;
    if (recorderRef.current) {
      recorderRef.current.stopRecording(() => {
        recorderRef.current = null;
      });
    }

    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close(1000, "Recording stopped by user");
    }

    stopTimer();
    setElapsedTime(0);
    setIsRecording(false);
    setIsPaused(false);
       eventBus.emit('refreshDashboard');
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleStartRecording = () => {
    if (!patientName) {
      setErrorMessage("enter patient name");
      return;
    }
    if (!patientId) {
      setErrorMessage("enter patient id ");
      return;
    }
    if (/^[^a-zA-Z0-9]+$/.test(patientName)&&mydata.usertype!='PRO') {
  setErrorMessage('Invalid patient name: cannot contain only special characters');
  return;
}

if (patientId.replace(/^0+|0+$/g, '') === ''&&mydata.usertype!='PRO') {
    setSeverity('error')
    setAlertMessage('Invalid patient ID: cannot be only zero(s)')
    setOpen(true)
    return;
  }
  
    startRecording();
    setDetailsModal(false);
    
  };
  const onExit = () => {
    if (ismanualrecordstart.current) {
      stopmanualRecording();
      stopRecording();
      setExitModal(false);
      setModalValue({recording:false})
      setAlertMessage("Your Recording is Successfully Completed!");
      setSeverity("success"); // Change severity as needed
      handleeditscreen({ id: patientId, name: patientName });
      setUi(0);
      
      return;
    }
    stopRecording();
    setAlertMessage("Your Recording is Successfully Completed!");
    setSeverity("success"); // Change severity as needed
    setOpen(true);
    setExitModal(false);
   
    handleeditscreen({ id: patientId, name: patientName });
    setUi(0);
  };
  const deleteStream = async () => {
    try {
      setModalValue({recording:false})
      setLoading(true);
      if(mydata.usertype==='PRO'){
     setstatus({status:"active",appointmentid:mydata.selectedRecord?.appointmentid})
      }
 
      const response = await api.post(
        `/v1/recording/streaming/cancel?stream_filename=${streamfilename}`
      );
      if (response.status === 200) {
        if (ismanualrecordstart.current) {
          blocker.current = true;
          stopmanualRecording();
        }

        stopRecording();
        setExitModal(false);
    
        stopRecording();
        setUi(0)
        setAlertMessage("Your Recording is Successfully cancelled");
        setSeverity("error"); // Change severity as needed
        setOpen(true);
      } 
    } catch (error) {
      console.log(error);
    } finally {
      blocker.current = false;
      setPatientName('');
      setPatientId('');
      setLoading(false);
      setDeleteConfirmationModal(false);
    }
  };

  
  const FetchRecorderData = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `/v1/appointments/get/${mydata.selectedRecord?.appointmentid}`
      );
      let appointmentsdata;
      if (response.status === 200) {
        appointmentsdata = await api.post(
          `/v1/patient/${response?.data?.patientid}/recording/details`,
          {
            filter_array: {
              date_filter: {},
            },
          }
        );
      }

      if (response.status == 200) {
        setPageData(response?.data)
    
        return [response?.data, appointmentsdata?.data];
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleeditscreen = ({ id, name }) => {
    setId(id);
    setName(name);
    setUi(1);
  };
  const handleCombine = (type) => {
  if(type==='combine'){
    combinestatus.current=true
    if(isuploadaudioflow.current){
      setStreamingCombine(false);
      setIsuploadmodal(true)
      return
    }
    startRecording();
    
  }else{
    if(isuploadaudioflow.current){
      setStreamingCombine(false);
      setIsuploadmodal(true)
      return
    }
    startRecording();
       
  }
  };
  const ExtractRos=async()=>{
    try {
      setAlertMessage('Getting Ros data...')
      setSeverity('info')
      setOpen(true)
      let appointment_date = mydata.selectedRecord?.startdate?.slice(0, 10)
      const response=await api.get(`/v1/patients/encounter-document-summary/${mydata.selectedRecord?.patientid}`,{
        params: {
          appointment_date: appointment_date
        }
      })
      if(response.status === 200 && response?.data?.summary?.hasOwnProperty('ros')){
        setRosData(response?.data?.summary?.ros||'')
  
      
      }else{
      setAlertMessage('No data found')
      setSeverity('info')
      setOpen(true)
  
      }
    } catch (error) {
      console.log(error)
    }finally{

    }
  }
  const fetchtimeline=async()=>{
    try {
      setIstimeLineLoading(true)   
     
      const response= await api.get(`/v1/patients/labs-timeline/${mydata.selectedRecord?.patientid}`)
  
      if(response.status===200){
        const reversedData = Object.fromEntries(Object.entries(response?.data || {}).reverse());
  setTimeLineData(reversedData);
  
  
  
      }else{
        setTimeLineData({})
      }
     
    } catch (error) {
      console.log(error)
    }finally{
  setIstimeLineLoading(false)
    }
  }

  const handleencounters=(prop)=>{
    setEncounterdata(prop)
    setIsEncounterModal(true)
      
    }
    



  const getimgs = async (prop) => {
  
    try {
      if (prop?.details?.title === "Medical Record"||Array.isArray(prop?.details?.images)) {
        setismrdata(prop);
        console.log(prop)
     setIsMrmodal(true);
      } else if (prop?.details?.images||prop?.details?.labs) {
        setLoading(true)
        let response={}
        if(prop?.details?.images){
     response=await api.get(`/v1/patients/imaging-summary/${mydata.selectedRecord?.patientid}/${prop?.date}`)
        }else{
    response=await api.get(`/v1/patients/labs-readings-summary/${mydata.selectedRecord?.patientid}/${prop?.date}`)
        }
      
     
     if(response?.status==200){
      setisimgdata(response?.data)
      setIsimgmodal(true)
     }else{
      setImgData([])
     }
      }else if(prop?.details?.encounter_summary){
        setLoading(true)
        const response=await api.get(`/v1/patients/encounter-summary/${prop?.details?.encounter_summary?.encounter_id}`)
  if(response.status===200){
    setvisitsummary(response.data)
    setIsvisitsummarymodal(true)
  }else{
    setvisitsummary({})
  }
  
      }
    } catch (error) {
      console.log(error)
    }finally{
  setLoading(false)
  
    }
   
  };
  const fetchimgdata=async()=>{
   try {
    setImgData([])
    const imgdata=await api.get(`/v1/patients/encounter-document/${mydata.selectedRecord?.patientid}`)
    if(imgdata.status===200){
      setImgData(imgdata?.data||[])
    }else{
      setImgData([])
    }
   } catch (error) {
    console.log(error)
   }finally{
  
   }
  }
    useEffect(() => {
    if (recentRecord?.transcriptionstatus === "Processing" && !pollingRef.current) {
      console.log("Starting polling every 3 seconds...");

      pollingRef.current = setInterval(() => {
        fetchRecentRecord();
      }, 3000);
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
        console.log("Cleared polling on unmount");
      }
    };
  }, [recentRecord?.transcriptionstatus]);
const fetchRecentRecord = async () => {
  try {
    const today = dayjs(); // Local time

    const startDate = today.format('YYYY-MM-DD');
    const endDate = startDate;

    const startTime = today.startOf('day').format('HH:mm:ss.SSS[Z]');
    const endTime = today.endOf('day').format('HH:mm:ss.SSS[Z]');

    const response = await api.post(`/v1/patient/${mydata.selectedRecord?.patientid}/recording/details`, {
      filter_array: {
        date_filter: {
          start_date: startDate,
          end_date: endDate,
          startTime: startTime,
          endTime: endTime,
        },
      },
    });

    const records = response.data || [];

 const todayLocal = dayjs().format('YYYY-MM-DD');

const todayRecords = records.filter(record => {
  const recordDate = dayjs(record.ts).local().format('YYYY-MM-DD');
  return recordDate === todayLocal;
});


    if (todayRecords.length > 0) {
      // Sort by ts descending to get most recent first
      const sorted = [...todayRecords].sort((a, b) => 
        dayjs(b.ts).diff(dayjs(a.ts))
      );

      const mostRecent = sorted[0]; // First one is most recent
console.log(mostRecent,'mostrecent')
      // Optionally: set both
      setRecentRecord(mostRecent);
  

    } else {
      setRecentRecord({});
      console.log('No recent records found for today.');
    }

  } catch (error) {
    console.error('Error fetching recent record:', error);
  }
};

useEffect(()=>{
  if(mydata.selectedRecord?.patientid){
    fetchRecentRecord()
  }

},[mydata?.selectedRecord])
  return (
    <>
      <div className="min-h-screen h-auto flex">

       

        {/* Main Content - Takes Remaining Width */}
        <div className="flex-1 h-full flex flex-col">
          {/* UI Switcher */}
          {(() => {
            switch (ui) {
              case 0:
                case 2:
                return (
                  // <MainRecording
                  // isuploadaudioflow={isuploadaudioflow}
                  //   setui={setUi}
                  //   setRosData={ setRosData}
                  //   checkConsent={checkConsent}
                  //   selectedTemplate={selectedTemplate}
                  //   templates={templates}
                  //   selectedRecord={mydata.selectedRecord}
                  //   setSelectedTemplate={setSelectedTemplate}
                  //   setPatientId={setPatientId}
                  //   patientName={patientName}
                  //   patientid={patientId}
                  //   setPatientName={setPatientName}
                  //   errorMessage={errorMessage}
                  //   setErrorMessage={setErrorMessage}
                  //   isDetailsmoadal={showdetailsmodal}
                  //   setDetailsModal={setDetailsModal}
                  //   handleStartRecording={handleStartRecording}
                  //   setIsuploadmodal={setIsuploadmodal}
                  //   loguser={loguser}
                  // />
                  <CareIq
                   isuploadaudioflow={isuploadaudioflow}
                    setui={setUi}
                    setRosData={ setRosData}
                    checkConsent={checkConsent}
                    selectedTemplate={selectedTemplate}
                    templates={templates}
                    selectedRecord={mydata.selectedRecord}
                    setSelectedTemplate={setSelectedTemplate}
                    setPatientId={setPatientId}
                    patientName={patientName}
                    patientid={patientId}
                    setPatientName={setPatientName}
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    isDetailsmoadal={showdetailsmodal}
                    setDetailsModal={setDetailsModal}
                    handleStartRecording={handleStartRecording}
                    setIsuploadmodal={setIsuploadmodal}
                    loguser={loguser}
                    ui={ui}
                     handleencounters={handleencounters}
                  data={user}
                  getimgs={getimgs}
                  timelinedata={timelinedata}
                  imgdata={imgdata}
                  isTimeLineLoading={isTimeLineLoading}
                  ExtractRos={ExtractRos}
                  rosdata={rosdata}
             recentRecord={recentRecord}
                    isError={isError}
                    pausemanualRecording={pausemanualRecording}
                    audioStreamRef={audioStreamRef}
                    pausedref={pausedref}
                    isPaused={isPaused}
                    setIsPaused={setIsPaused}
                    togglePause={togglePause}
                    formatTime={formatTime}
                    elapsedTime={elapsedTime}
                    stopTimer={stopTimer}
                    setExitModal={setExitModal}
                
                    setDeleteConfirmationModal={setDeleteConfirmationModal}
                  
                  />
                );
              case 1:
                return <CareEditScreen
                setstatus={setstatus}
                clicked={recentRecord}
                // fetchdashboardData={fetchdashboardData}
                user={user}
                setui={setUi} id={id} name={name} />;
              // case 2:
              //   return (
              //     <Staticeditscreen
              //     handleencounters={handleencounters}
              //     data={user}
              //     getimgs={getimgs}
              //     timelinedata={timelinedata}
              //     imgdata={imgdata}
              //     isTimeLineLoading={isTimeLineLoading}
              //     ExtractRos={ExtractRos}
              //     rosdata={rosdata}
              //     setRosData={setRosData}
              //       isError={isError}
              //       pausemanualRecording={pausemanualRecording}
              //       audioStreamRef={audioStreamRef}
              //       pausedref={pausedref}
              //       isPaused={isPaused}
              //       setIsPaused={setIsPaused}
              //       togglePause={togglePause}
              //       formatTime={formatTime}
              //       elapsedTime={elapsedTime}
              //       stopTimer={stopTimer}
              //       setExitModal={setExitModal}
              //       patientName={patientName}
              //       setDeleteConfirmationModal={setDeleteConfirmationModal}
              //     />
              //   );
              default:
                return <div className="p-4"></div>;
            }
          })()}
        </div>
      </div>
      {isverified == 1 && (
        <AuthOverlayCard handleVerified={fetchuser} isOpen={true} />
      )}
      {isverified == 2 && (
        <TermsOverlayCard handleVerified={fetchuser} isOpen={true} />
      )}
      <DeleteConfirmation
        savemodal={deleteconfirmationModal}
        setModalOpen={setDeleteConfirmationModal}
        onExit={deleteStream}
      />
      <ExitModal
        savemodal={exitModal}
        setModalOpen={setExitModal}
        onExit={onExit}
      />
      {consentModal ? (
        <ConstentAcceptance
          handleAcceptance={handleAcceptance}
          ismodal={consentModal}
          setModal={setConsentModal}
        />
      ) : (
        <></>
      )}
      <StreamingCombineToastModal
        isModalOpen={streamingcombine}
        handlecombine={handleCombine}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={apploading || loading || getuserLoading}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
      <Encountermodal ismodal={isencountermodal}  setIsmodal={setIsEncounterModal} data={encounterdata}/>
      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
      <ImageModal ismodal={isimgmodal} setIsModal={setIsimgmodal} imagingdata={isimgdata}/>
    <VisitSummarymodal ismodal={isvisitsummarygmodal} setIsModal={setIsvisitsummarymodal} imagingdata={visitsummarydata}/>
        <MRModal ismodal={ismrmodal} setIsModal={setIsMrmodal} imagingdata={ismrdata}/>
      {isuploadmodal?<UploadAudio 
      isuploadaudioflow={isuploadaudioflow}
      latestapp={latestapp}
      combinestatus={combinestatus}   
      selectedTemplate={selectedTemplate}     
         setIsuploadmodal={setIsuploadmodal}/>:<></>}
  
   
    </>
  );
};

export default V2Dashboard;
